import React from 'react'
import PropTypes from 'prop-types'
import { enhanceForms } from './templateFormValidation'
import { enhanceInteractions } from './templateInteractions'

// Templates are full HTML documents, so they render in an iframe to keep their
// styles isolated. Scripts stay disabled because the HTML is user-authored;
// allow-same-origin lets this app attach form validation from outside.
const SANDBOX = [
  'allow-same-origin',
  'allow-forms',
  'allow-popups',
  'allow-popups-to-escape-sandbox',
  'allow-top-navigation-by-user-activation',
].join(' ')

function TemplateFrame({ html, title, onFormSubmit, prepareDocument }) {
  const handleLoad = (event) => {
    const doc = event.currentTarget.contentDocument
    if (!doc) return
    if (prepareDocument) prepareDocument(doc)
    enhanceInteractions(doc)
    enhanceForms(doc, { onValidSubmit: onFormSubmit })
  }

  return (
    <iframe
      className="lg-template-frame"
      srcDoc={html}
      title={title}
      sandbox={SANDBOX}
      onLoad={handleLoad}
    />
  )
}

TemplateFrame.propTypes = {
  html: PropTypes.string,
  title: PropTypes.string,
  onFormSubmit: PropTypes.func,
  prepareDocument: PropTypes.func,
}

export default TemplateFrame
